<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      :line-form="true"
      :title="(isReview?'审核':'查看')+' 盘点单'"
      id-key="DocId"
      :data="data"
      @edit-opened="isReview=true"
      @details-opened="isReview=false"
      :get-data-func="api.info"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="8">
              <el-form-item label="单据编号">
                <span class="detail-span">{{data.DocNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单据日期">
                <span class="detail-span">{{$commonJs.toDateString(data.DocDate)}}</span>
              </el-form-item>
            </el-col>
                  <el-col :span="8">
              <el-form-item label="盘点仓库">
                <span class="detail-span">{{data.WarehouseName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        
          <el-row>
              <el-col :span="8">
              <el-form-item label="盘点人员">
                <span class="detail-span">{{data.EmpName}}</span>
              </el-form-item>
            </el-col>
              <el-col :span="8">
              <el-form-item label="账面日期">
                <span class="detail-span">{{data.BookDate}}</span>
              </el-form-item>
            </el-col>
               <el-col :span="8">
              <el-form-item label="盘点方式">
                <span class="detail-span">{{data.InventoryWay==0?'实物盘点':'商品清单盘点'}}</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="业务类型">
                <span class="detail-span">
                  <span v-if="data.BusinessType==0">应收款</span>
                  <span v-if="data.BusinessType==1">预收款</span>
                  <span v-if="data.BusinessType==2">直接收款</span>
                </span>
              </el-form-item>
            </el-col> -->
          </el-row>
     
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <span class="detail-span">{{data.Remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <!-- <div class="row-tb-head" style="margin-top: 10px;">
          <span>收款信息</span>
        </div> -->
        <el-table ref="table" class="tb-c-head"  :data="data.Goods"  show-summary :summary-method="getSummaries" border style="margin-top: 10px;">
          <el-table-column label="条码" prop="BarCode" min-width="120px" />
          <el-table-column label="商品名称"  prop="GoodsName" min-width="150px"/>  
          <el-table-column label="规格型号" prop="Model"  />
          <el-table-column label="单位" prop="UnitName"  />
          <el-table-column label="盘点数量" prop="Quantity"  />
          <!-- <el-table-column label="调出单价" prop="OutCost"  /> -->
          <el-table-column label="账面数量" prop="InventoryQuantity"  />
          <el-table-column label="盈亏数量" prop="DiffQuantity"  />
          <el-table-column label="备注" prop="Remark"  min-width="200px"/>
        </el-table>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <template v-if="isReview==true">
          <el-button :loading="isLoading" type="success" size="mini" @click="save('examine')">审 核</el-button>
        </template>
        <template v-if="isReview==false">
          <el-button :loading="isLoading" type="danger" size="mini" @click="save('cancelExamine')">弃 审</el-button>
        </template>
        <el-button @click="close" size="mini">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/stock/inventory").default,
      data: {
         DocId: 0,
        DocNo: "",
        DocDate: "",
        DocType: 0,
        Remark: "",
        OrderNo: "",
        OrderId: 0,
        WarehouseId: null,
        Status: 0,
        WarehouseName:"",
        Goods: [],
        AllotType:"",
        EmpName:"",
        BookDate:"",
        InventoryWay:"",
      },
      isReview: null,
    };
  },
  mounted() {},
  methods: {
    // 非分页 千位符+保留后两位
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity1', 'NoTaxAmount', 'Quantity2', 'Quantity', 'CostPrice', 'TaxAmount', 'Amount', 'Offer'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            // 数量字段，保留4位小数  
            if (['Quantity', 'Quantity1', 'Quantity2'].includes(field)) {
              sums[index] = Math.round(sums[index]*Math.pow(10,4))/Math.pow(10,4); 
            } else {
              sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    save(type) {
      
      this.$refs.dialog.isLoading = true;
      this.api[type](this.data.DocId).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.isReview = null;
    },
  },
};
</script>